import React from 'react';
import { useSelector } from 'react-redux';

import { Container, Nav, Navbar } from 'react-bootstrap';
import Brand from './Brand';
import CartLink from './CartLink';
import LoginRegisterLinks from './LoginRegisterLinks';
import NavLink from './NavLink';
import UserDropdown from './UserDropdown';

import useHeader from './useHeader';
import {
  STR_GALLERY,
  STR_STORE,
  URL_COLOR_GENIE_PUBLIC,
  URL_GALLERY,
  URL_STORE,
} from '../../utils/constants';
import { trackMainMenuNavigateClick } from '../tracking/discovery.tracking';

const handleBlogLinkClick = () => {
  trackMainMenuNavigateClick('Blog');
};

const Header = () => {
  const user = useSelector((state) => state.auth);
  const { showHeader } = useHeader();

  if (!showHeader) return null;

  return (
    <header id='header' className='pt-3'>
      <Navbar expand='lg' collapseOnSelect>
        <Container>
          <Brand />
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ml-auto'>
              <NavLink url={URL_STORE} title={STR_STORE} />
              <NavLink url={URL_GALLERY} title={STR_GALLERY} />
              <NavLink url={URL_COLOR_GENIE_PUBLIC} title='Color Genie' />
              <a
                href='https://blog.askokey.com'
                className='nav-link'
                onClick={handleBlogLinkClick}
              >
                Blog
              </a>

              {user ? <UserDropdown user={user} /> : <LoginRegisterLinks />}

              <CartLink />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
